module.exports = __webpack_public_path__ + "static/img/ikonaNotatka-OFF.bf5dda55.png";